<template>
    <div class="page-layout__inner">
        <div class="page-layout__content">
            <p class="page-layout__descr  text">{{getTranslation('foundWithQuantity',pagination.total)}}</p>
            <div class="page-layout__group">
                <section class="section">
                    <table class="table-3 table-borderless">
                        <thead class="table-3__head scroll-here">
                            <tr class="table-3__row">
                                <th colspan="4" class="table-3__cell  table__hcell">
                                    <form method="get" @submit.prevent="fetchLanguages">
                                        <div class="field-advanced">
                                            <div class="field-advanced__inner">
                                                <div class="field-advanced__field-wrap">
                                                    <input v-model="filterForm.query" class="field  field--full-width  field--bg-grey  js-borderOnFocus" type="text" :placeholder="getTranslation('searchPhrase')">
                                                </div>

                                                <div class="field-advanced__right">
                                                    <button class="btn  btn--square  btn--main">
                                                        <svg class="btn__icon">
                                                            <use xlink:href="#icon__search" />
                                                        </svg>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </th>
                            </tr>
                            <tr class="table-3__row">
                                <th class="table-3__cell  table__hcell" style="width: 5%">#</th>
                                <th class="table-3__cell  table__hcell" style="width: 20%">{{getTranslation('key')}}</th>
                                <th class="table-3__cell  table__hcell" style="width: 40%">{{$lang.app.ru_RU}}</th>
                                <th class="table-3__cell  table__hcell" style="width: 40%">{{$lang.app.ky_KG}}</th>
                                <th class="table-3__cell  table__hcell" />
                            </tr>
                        </thead>
                        <tbody class="table-3__body">
                            <tr v-for="(language,key) in languages" class="table-3__row">
                                <td class="table-3__cell">{{language.id}}</td>
                                <td class="table-3__cell">{{language.name}}</td>
                                <td v-for="translation in language.translates" class="table-3__cell">
                                    {{translation.translate}}
                                </td>
                                <td class="table-3__cell row">
                                    <ActionsComponent v-on:edit="initUpdate(language)" :has-delete="false" :has-password="false" :has-edit="hasPermission('api.languages.update')" />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </section>
            </div>
            <div class="page-layout__pagination" v-if="pagination.total && pagination.lastPage > 1">
                <pagination :pagination="pagination" @change="()=>{fetchLanguages();this.$scrollTo('.scroll-here');}" v-model="filterForm.page" />
            </div>
        </div>
        <!--  modal  -->
        <modal
                v-model="showModal"
                :modal-title="getTranslation('add')"
                :ok-button-label="getTranslation('save')"
                :cancel-button-label="getTranslation('cancel')"
                @ok-button-click="save"
                @cancelButtonClick="reset"
                @input="reset"
        >
            <form class="form w-100">
                <span class="text-danger">* {{getTranslation('required')}}</span>
                <div class="form__group">
                    <label class="form__label   form__label--block">{{getTranslation('key')}}</label>
                    <input :disabled="edit" class="field field--full-width" v-model.trim="form.name" type="text">
                    <div v-if="$v.form.name.$error" class="form__error">{{ getTranslation('requiredField') }}<span class="required">*</span></div>
                </div>
                <div v-for="locale in locales" class="form__group">
                    <label class="form__label   form__label--block" for="shortArea">{{$lang.app[locale.title]}}<span class="required">*</span></label>
                    <textarea v-model.trim="form[locale.title]" class="field  field--full-width  field--short-area" name="" id="shortArea" cols="30" rows="10" />
                </div>
            </form>
        </modal>
    </div>
</template>

<script>
    import required from "vuelidate/lib/validators/required";

    export default {
        name: "Index",
        data() {
            return {
                form: {
                    name: '',
                },
                pagination: {
                    total: 0,
                    lastPage: '',
                    currentPage: ''
                },
                filterSettings: {
                    visible: true
                },
                filterForm: {
                    page: this.$route.query.page || 1,
                },
                edit: false,
                languages: [],
                locales: [],
                showModal: false
            }
        },
        updated() {
            let actions = [];
            if ( this.hasPermission( 'api.languages.create' ) )
                actions.push( {
                    label: this.getTranslation( 'add' ),
                    action: this.setModal,
                    icon: {
                        icon: '#icon__square-add'
                    }
                } );

            this.setHeadings( {
                title: this.getTranslation( 'languages' ),
                actions: actions
            } );
        },
        created() {
            this.fetchLanguages();
            this.fetchLocales();
        },
        methods: {
            initUpdate( language ) {
                this.edit = true;
                this.form.name = language.name;
                this.form.id = language.id;
                for ( let locale of this.locales ) {
                    for ( let translation of language.translates ) {
                        if ( locale.title === translation.locale )
                            this.form[locale.title] = translation.translate;
                    }
                }
                this.setModal();
            },
            updateLanguage() {
                return this.axios.put( this.$config.urls.language.fetchLanguage.url.replace( ':id', this.form.id ), this.form )
                           .then( () => {
                               this.snotifySuccess( 'updateSuccessMsg' );
                               this.showModal = false;
                               this.fetchLanguages();
                           } ).catch( () => {
                        this.snotifyError( 'serverError' );
                    } )
                           .finally( () => {
                               this.loadLocale();
                               this.reset();
                           } );
            },
            deleteLanguage( id ) {
                this.axios.delete( this.$config.urls.language.fetchLanguage.url.replace( ':id', id ) ).then( response => {
                    if ( response.status === 200 )
                        this.$snotify.success( this.getTranslation( 'deleteSuccessMsg' ) );
                    else
                        this.$snotify.error( this.getTranslation( 'serverError' ) );
                } )
            },
            setModal() {
                this.showModal = true;
                if ( !this.edit )
                    this.reset();
            },
            save() {
                if ( this.edit )
                    this.updateLanguage();
                else
                    return this.axios.post( this.$config.urls.language.fetchLanguages.url, this.form )
                               .then( () => {
                                   this.$snotify.success( this.getTranslation( 'saveSuccessMsg' ) );
                                   this.showModal = false;
                                   this.fetchLanguages();
                                   this.reset();
                               } ).catch( () => {
                            this.$snotify.error( this.getTranslation( 'serverError' ) )
                        } )
                               .finally( () => {
                                   this.loadLocale();
                               } );
            },
            reset() {
                this.edit = false;
                this.form = {
                    name: ''
                }
            },
            fetchLanguages() {
                let filter = {
                    page: this.filterForm.page
                };
                if ( this.filterForm.query )
                    filter['query'] = this.filterForm.query;

                this.$router.replace( { query: filter } ).catch( () => {
                } );
                return this.axios.get( this.$config.urls.language.fetchLanguages.url, { params: filter } ).then( response => {
                    this.languages = response.data.data.items;
                    this.pagination.currentPage = response.data.data.activePage;
                    this.pagination.total = response.data.data.totalItemsCount;
                    this.pagination.lastPage = response.data.data.pages;
                } ).catch(()=>{});
            }
        },
        validations: {
            form: {
                name: {
                    required
                },
            }
        }
    }
</script>

<style scoped>

</style>
